import { connect } from "react-redux";
import SelectCallFlowComponent from "../../Components/AgentAI/SelectCallFlowComponent";

const mapStateToProps = (state) => ({
  CALL_FLOWS: state.reducer.CALL_FLOWS,
});

const mapDispatchToProps = (dispatch) => ({});

export default connect(mapStateToProps, mapDispatchToProps)(SelectCallFlowComponent);
